<template>
    <section>
        <div class="spacing-large vertical-center">
            <div>

                <h2>VoLTE - the foundation of 5G voice</h2>
                <p>Your 4G LTE coverage and VoLTE provide the basis of 5G voice services. That’s because coverage is already in place and the same IMS core can be used for 5G with minimal or even no changes needed.</p>

            </div>
        </div>
        <div class="spacing-small center gray">

            <img src="~@/assets/images/chapter-3/architectural-evolution-2.png" alt="">

        </div>
    </section>
</template>

<script>

    import globalMixin from '@/mixins/globalMixin.js';

    export default {
        mixins: [globalMixin],
    }

</script>

<style lang="scss" scoped>

    .vertical-center {
        display: flex;
        align-items: center;
    }

</style>